const tableStyle = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: '56rem', // Adjust the overall container height as needed
  },
  tableContainer: {
    maxHeight: '51rem', // Reduce the maxHeight to allow for the header's height
    overflow: 'auto', // Allow the table container to scroll
    border: '1px solid rgba(0, 0, 0, 0.16)',
    borderRadius: '6px',
  },
  tableHead: {
    fontFamily: 'Schibsted Grotesk',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '125%',
    '& th': {
      padding: '16px 0px !important',
    },
  },
  tableBody: {
    fontSize: '16px',
    // You can remove the maxHeight and overflowY properties from here
    '&::-webkit-scrollbar': {
      width: '4px',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.24)',
      borderRadius: '4px',
    },
    '& .MuiTableCell-root': {
      padding: '12px 0px !important',
    },
    '& .errorClass': {
      borderBottom: '1px solid red',
    },
  },
  tableCellHeader: {
    color: 'gray',
    fontSize: '14px',
  },
};
  
export default tableStyle;